import EmblaCarousel from "embla-carousel"
import { addPrevNextBtnsClickHandlers } from "./embla/arrows"
import { addDotBtnsAndClickHandlers } from "./embla/dots"

export default class MegaMenu {
  constructor() {
    this.emblaNode = document.querySelector(".mega-menu .embla")
    this.viewportNode = document.querySelector(".mega-menu .embla__viewport")

    this.leftEdge = document.querySelector(".mega-menu .gallery-edge--start")
    this.rightEdge = document.querySelector(".mega-menu .gallery-edge--end")

    this.prevBtnNode = document.querySelector(".mega-menu .embla__button--prev")
    this.nextBtnNode = document.querySelector(".mega-menu .embla__button--next")
    this.dotsNode = document.querySelector(".mega-menu .embla__dots")

    if (this.emblaNode && this.viewportNode) {
      this.emblaApi = EmblaCarousel(this.viewportNode, {
        align: "start",
        dragThreshold: 5,
      })

      this.emblaApi.on("init", () => {
        this.toggleEdges()
      })

      this.emblaApi.on("resize", () => {
        this.toggleEdges()
      })

      this.emblaApi.on("scroll", () => {
        this.toggleEdges()
      })

      const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
        this.emblaApi,
        this.prevBtnNode,
        this.nextBtnNode,
      )
      const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(this.emblaApi, this.dotsNode)

      this.emblaApi.on("destroy", removeDotBtnsAndClickHandlers)
      this.emblaApi.on("destroy", removePrevNextBtnsClickHandlers)
    }
  }

  toggleEdges() {
    const progress = Math.round(this.emblaApi.scrollProgress() * 100)

    if (progress <= 0) {
      this.leftEdge.classList.remove("is-visible")
    } else {
      this.leftEdge.classList.add("is-visible")
    }

    if (progress === 100) {
      this.rightEdge.classList.remove("is-visible")
    } else {
      this.rightEdge.classList.add("is-visible")
    }
  }
}
